import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import Select from 'react-select';
import axios from 'axios';
import $ from 'jquery';
const ViewAmenities = (props) => {

    const [items, setitems] = useState([]);
    useEffect(() => {
        setTimeout(() => {
            $('#example3').DataTable().destroy()
            populatedata()
        }, 100)

    }, []);
    useEffect(() => {
        $('#example3').DataTable();
    }, [items]);

    async function populatedata() {
        const url = process.env.REACT_APP_APIURL + "FarmAmenity/GetFarmAmenitys?companyid="+props.companyid;
        await fetch(url).then(res => res.json()).then(result =>
            setitems(result)
        );
    }
     async function deletedata(id) {
         const urldelete = process.env.REACT_APP_APIURL + 'FarmAmenity/DeleteFarmAmenity?FarmAmenityid='+id;
         let res = await axios.post(urldelete);
         if (res.status == 200) {
             swal({
                 title: "Deleted Successfully",
                 icon: "success"
             })
             populatedata();

         }
    }

    async function handleEdit(id) {
        const url = process.env.REACT_APP_APIURL + "FarmAmenity/GetFarmAmenity?FarmAmenityid="+id+"&companyid="+props.companyid;
        await fetch(url).then(res => res.json()).then(result => {
            
            setupdateitems({ ...updateitems, AmenityId: result.amenityId, AmenityName: result.amenityName, Description: result.description, UnitId: result.unitId })
            setunitvalue({ ...unitvalue, value: result.unitId, label: result.unitName })
        });
        $("#myModal").modal('show');
    }
    function handleDelete(id) {
        swal({
            title: "Are you sure?",
            //  text: "Once deleted, you will not be able to recover this imaginary file!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete)
            {
                deletedata(id);
              
            } else {
                swal("0 Rows deleted");
            }
        });
    }
    ///////////////////////////////////////////////////////////
   ////////////////////update amenities///////////////////////
    ///////////////////////////////////////////////////////////
    const [updateitems, setupdateitems] = useState({ AmenityId: "", AmenityName: "", Description: "", UnitId: "", company_id: props.companyid })
    const [addunit, setunit] = useState({})
    const [unitvalue, setunitvalue] = useState()
    // 
    useEffect(() => {
        fetchdata();
    }, [])

    async function fetchdata() {
        const Uniturl = process.env.REACT_APP_APIURL + "FramUnit/GetFramUnits?companyid=" + props.companyid;
        let Unitdata = await axios.get(Uniturl);
        var units = [];
        Unitdata.data.map((u) => {
            units.push({ value: u.unitId, label: u.unitName });
        })
        setunit(units);
    }

    const handleInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setupdateitems({ ...updateitems, [name]: value })
    }
    const handleSelect = e => {
        const value = e.value;
        setunitvalue(e)
        setupdateitems({ ...updateitems, UnitId: value })
    }
    const refresh = () => {
        setupdateitems({ ...updateitems, AmenityName: "", Description: "", UnitId: "", company_id: props.companyid });
        setunitvalue(null)
    }
    const savemethod = async (data) => {
        const url = process.env.REACT_APP_APIURL + "FarmAmenity/UpdateFarmAmenity";
        await fetch(url, {
            method: "POST",
            headers: {
                'Accept': "json",
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(res => {
            if (res.status == 200) {
                swal({
                    title: "Saved Successfully",
                    //  text: "Once deleted, you will not be able to recover this imaginary file!",
                    icon: "success"
                })
                refresh();
                populatedata();
                $("#myModal").modal("hide")
            }
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        savemethod(updateitems);
    }
    return (
        <div className="row">
            <div className="col-12">
                <div className="card">
                    <div className="card-header">
                        <h3 className="me-auto mb-0">View Amenities List</h3>
                    </div>
                    <div className="card-body">

                        <div className="table-responsive">
                            <table id="example3" className="display" data-page-length='50'>
                                <thead>
                                    <tr>
                                        <th>Amenity Name</th>
                                        <th>Description</th>
                                        <th>Unit</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map(item =>
                                        <tr key={item.amenityId}>
                                            <td>{item.amenityName}</td>
                                            <td>{item.description}</td>
                                            <td>{item.unitName}</td>
                                            <td>
                                                <span className="d-flex">
                                                    <button href="#" className="btn btn-primary shadow btn-xs sharp me-2"
                                                        onClick={() => handleEdit(item.amenityId)}>
                                                        <i className="fas fa-pencil-alt"></i>
                                                    </button>
                                                    <button href="#" className="btn btn-danger shadow btn-xs sharp"
                                                        onClick={() => handleDelete(item.amenityId)}>
                                                        <i className="fa fa-trash"></i>
                                                    </button>
                                                </span>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div id="myModal" className="modal fade " tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="card">
                            <div className="card-header">
                                <h3 className="me-auto mb-0">Update Amenities</h3>
                            </div>
                            <div className="card-body">
                                <div className="basic-form">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="mb-3 col-sm-6">
                                                <label className="form-label">Amenities Name</label>
                                                <input type="text" autoComplete="off" name="AmenityName" value={updateitems.AmenityName} onChange={handleInput} className="form-control" required />
                                            </div>
                                            <div className="mb-3 col-sm-6">
                                                <label className="form-label">Unit</label>
                                                <Select options={addunit} value={unitvalue} onChange={handleSelect} />

                                            </div>
                                            <div className="mb-5 col-12">
                                                <label className="form-label">Description</label>
                                                <textarea className="form-control" name="Description" value={updateitems.Description} onChange={handleInput} ></textarea>
                                            </div>
                                        </div>
                                        <button type="submit" className="btn btn-primary">Submit</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ViewAmenities;